import { useEffect } from 'react';

/**
 * Sets `<meta name="theme-color">` — the colour of the browser's address bar
 * and, in an installed PWA, Android's status bar — for the part of the app
 * that is mounted (F1, K10).
 *
 * One bundle serves every portal, so a static value cannot be right for all
 * of them: each top-level ThemeProvider in App.tsx renders one of these. The
 * client and worker portals (and the public client-themed pages) pass the
 * brand fill #F5833F; the admin-themed routes pass the admin primary
 * #1976d2. `index.html` and the manifest carry the brand value as the
 * pre-JavaScript default. The last mounted route wins; a route never restores
 * the old value on unmount, because the next route sets its own.
 *
 * Renders nothing.
 */
export function ThemeColorMeta({ color }: { color: string }) {
  useEffect(() => {
    let meta = document.head.querySelector<HTMLMetaElement>('meta[name="theme-color"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'theme-color';
      document.head.appendChild(meta);
    }
    meta.content = color;
  }, [color]);
  return null;
}
